import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Switch } from "@material-ui/core";
import {
  grey300,
  lightGrey,
  newPaletteSecondary,
  primary,
  primaryLight,
  secondary,
  warning,
} from "../../../../infrastructure/theme/customColors";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "65vw",
  },
  subtitle: {
    color: grey300,
    marginTop: -theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  vendorLogo: {
    height: 150,
  },
  serviceSwitchContainer: {
    padding: theme.spacing(2),
    cursor: "pointer",
  },
  configContainer: {
    padding: theme.spacing(2),
    backgroundColor: lightGrey,
  },
  serviceIsSelected: {
    backgroundColor: lightGrey,
  },
  buttonBar: {
    paddingTop: theme.spacing(2),
  },
  chipContainer: {
    padding: theme.spacing(1),
  },
  chip: {
    marginRight: theme.spacing(1),
    backgroundColor: "transparent",
    border: `2px solid ${grey300}`,
  },
  productSwitchContainer: {
    padding: theme.spacing(1),
  },
  productIsSelected: {
    backgroundColor: lightGrey,
  },
  activeChip: {
    borderColor: primary,
    backgroundColor: primaryLight,
  },
  percentageAppliedRow: {
    padding: theme.spacing(1),

    "& fieldset": {
      marginRight: theme.spacing(1),
    },
  },
  loaderContainer: {
    padding: theme.spacing(4),
  },
  linkText: {
    color: secondary,
  },
  rowSpacing: {
    paddingBottom: theme.spacing(4),
  },
  attachmentRow: {
    padding: `${theme.spacing(1)}px 0`,
  },
  warningIcon: {
    color: warning,
  },
}));

export const WellnessSwitch = withStyles({
  switchBase: {
    color: newPaletteSecondary,
    "&$checked": {
      color: newPaletteSecondary,
    },
    "&$checked + $track": {
      backgroundColor: newPaletteSecondary,
    },
  },
  checked: {},
  track: { opacity: 0.3 },
})(Switch);

export default useStyles;
